import type { CtcaeTerm, Grade } from "./types";

const ALL_GRADES: Grade[] = [1, 2, 3, 4, 5];

function joinGradeSegments(segments: string[]) {
  if (segments.length === 1) return segments[0];
  if (segments.length === 2) return `${segments[0]} and ${segments[1]}`;
  return `${segments.slice(0, -1).join(", ")}, and ${segments.at(-1)}`;
}

export function gradeCriteriaLabel(grades: CtcaeTerm["grades"]) {
  const available = ALL_GRADES.filter((grade) => Boolean(grades[String(grade) as keyof typeof grades]?.trim()));
  if (!available.length) return "No grade criteria";

  const ranges: Array<{ first: Grade; last: Grade }> = [];
  for (const grade of available) {
    const current = ranges.at(-1);
    if (current && grade === current.last + 1) current.last = grade;
    else ranges.push({ first: grade, last: grade });
  }

  const segments = ranges.map(({ first, last }) => first === last ? `${first}` : `${first}–${last}`);
  return `${segments.length === 1 ? "Grade" : "Grades"} ${joinGradeSegments(segments)}`;
}
